export type LegacyManagerRole = 'photo' | 'director' | 'counselor' | 'make' | 'video' | 'tm'

export interface LegacyManagerOffice {
  id: string
  name: string
}

export interface LegacyManagerStaff {
  id: string
  managerId: string
  username: string
  name: string
  level: '지점 매니저' | '직원' | 'TM 담당자'
  officeId: string
  officeName: string
  roles: Record<LegacyManagerRole, boolean>
  signature?: string
  added?: boolean
}

export const legacyManagerOffices: LegacyManagerOffice[] = [
  { id: '1', name: '모의지점 A' },
  { id: '2', name: '모의지점 B' },
  { id: '3', name: '모의지점 C' },
]

const mockSignature = (index: number) => `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="140" height="32" viewBox="0 0 140 32"><path d="M6 ${22 - index} C25 4,33 30,50 12 S75 28,92 10 S113 25,134 8" fill="none" stroke="#38506b" stroke-width="2" stroke-linecap="round"/><path d="M42 26 H126" stroke="#8ca0b3" stroke-width="1"/></svg>`)}`

export const legacyManagerStaff: LegacyManagerStaff[] = Array.from({ length: 18 }, (_, index) => {
  const office = legacyManagerOffices[index > 14 ? 1 : 0]
  return {
    id: `${index + 1}`,
    managerId: `manager-${index + 1}`,
    username: `mock_user_${String(index + 1).padStart(2, '0')}`,
    name: `모의직원 ${String(index + 1).padStart(2, '0')}`,
    level: index === 0 ? '지점 매니저' : index % 7 === 0 ? 'TM 담당자' : '직원',
    officeId: office.id,
    officeName: office.name,
    roles: {
      photo: index % 2 === 0,
      director: index % 3 === 0,
      counselor: index % 4 !== 0,
      make: index % 5 === 0,
      video: index % 6 === 0,
      tm: index % 7 === 0,
    },
    signature: index < 4 ? mockSignature(index) : undefined,
  }
})

export const legacyOtherOfficeStaff: LegacyManagerStaff[] = Array.from({ length: 15 }, (_, index) => {
  const office = legacyManagerOffices[(index % 2) + 1]
  return {
    id: `other-${index + 1}`,
    managerId: '',
    username: `other_mock_${String(index + 1).padStart(2, '0')}`,
    name: `타지점 모의직원 ${String(index + 1).padStart(2, '0')}`,
    level: index % 6 === 0 ? 'TM 담당자' : '직원',
    officeId: office.id,
    officeName: office.name,
    roles: { photo: false, director: false, counselor: true, make: false, video: false, tm: false },
  }
})

export const legacyManagerRoleLabels: Array<{ id: LegacyManagerRole; label: string }> = [
  { id: 'photo', label: '촬영자' },
  { id: 'director', label: '연출자' },
  { id: 'counselor', label: '상담자' },
  { id: 'make', label: '메이크업' },
  { id: 'video', label: '영상편집' },
  { id: 'tm', label: 'TM담당' },
]
